import { useTranslation } from 'react-i18next';
import { DocumentStatus } from '@/types';
import { ProgressBar } from 'react-bootstrap';
import { StyledBadge, ProgressBarThin } from './DocumentStatusBadge.styled';

interface DocumentStatusBadgeProps {
  status: DocumentStatus;
  processingProgress?: number;
  showProgress?: boolean;
}

const STATUS_CONFIG: Record<DocumentStatus, { labelKey: string; modifier: 'uploaded' | 'processing' | 'ready' | 'failed' }> =
  {
    [DocumentStatus.Uploaded]: { labelKey: 'status.uploaded', modifier: 'uploaded' },
    [DocumentStatus.Processing]: { labelKey: 'status.processing', modifier: 'processing' },
    [DocumentStatus.Ready]: { labelKey: 'status.ready', modifier: 'ready' },
    [DocumentStatus.Failed]: { labelKey: 'status.failed', modifier: 'failed' },
  };

export default function DocumentStatusBadge({
  status,
  processingProgress = 0,
  showProgress = false,
}: DocumentStatusBadgeProps) {
  const { t } = useTranslation();
  const config = STATUS_CONFIG[status];

  return (
    <div className="d-flex flex-column gap-1">
      <StyledBadge $modifier={config.modifier}>{t(config.labelKey)}</StyledBadge>
      {showProgress && status === DocumentStatus.Processing && (
        <ProgressBarThin>
          <ProgressBar now={processingProgress} variant="primary" animated />
        </ProgressBarThin>
      )}
    </div>
  );
}
